import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import i18next from 'i18next';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import Availability from './availability/Availability'
import Exception from './exception/Exception'
import { getAccessTab } from '../../utils/menuHelper';
import * as keyMenu from '../../scripts/KeyMenu';

import { withNamespaces } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function TabPanelScheduleAvailability() {
    const [value, setValue] = React.useState(0);
    const [index, setIndex] = React.useState(0);
    const [hasAvailibility, setHasAvailibility] = React.useState(false);
    const [hasException, setHasException] = React.useState(false);
    const [isDenied, setIsDenied] = React.useState(false);

    useEffect(() => {
        validateAccessTab();
    }, [])

    const validateAccessTab = () => {
        const isTabAvailability = getAccessTab(keyMenu.TAB_AVAILABILITY);
        const isTabException = getAccessTab(keyMenu.TAB_EXCEPTION);

        setHasAvailibility(isTabAvailability);
        setHasException(isTabException);

        setIsDenied(!isTabAvailability && !isTabException);

        if (!isTabAvailability) {
            setIndex(1);
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleItemAvailibilityClick = () => {
        setIndex(0);
    }

    const handleItemExceptionClick = () => {
        setIndex(1);
    }

    const classes = useStyles();

    return (
        <div className={classes.divRoot}>
            {isDenied && i18next.t("scheduleAvailability:tabPanel.noAccess")}
            {!isDenied && <AppBar position="static" color="default">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="standard"
                    indicatorColor="primary"
                    textColor="primary"
                    className={"TabPage"}
                >
                    {hasAvailibility && <Tab className={"TabPageButton"} label={i18next.t("scheduleAvailability:tabPanel.availability")} {...a11yProps(0)} onClick={handleItemAvailibilityClick} />}
                    {hasException && <Tab className={"TabPageButton"} label={i18next.t("scheduleAvailability:tabPanel.exception")} {...a11yProps(1)} onClick={handleItemExceptionClick} />}
                </Tabs>
            </AppBar>}

            {!isDenied && index == 0 && hasAvailibility && <Availability />}
            {!isDenied && index == 1 && hasException && <Exception />}
        </div>
    );
}

export default withNamespaces(['scheduleAvailability'], { wait: true })(TabPanelScheduleAvailability);